import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { MainLayoutPage } from 'LayoutPages'
import { GlobalMenu } from 'scene/Layout/GlobalMenu';

import RequestACallForm from 'pages/Global/requestCall/RequestACallForm';


const isIOS = () => {
    return (
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document)
    );
};


const RequestACallPage = () => {

    const { QRcode } = useParams();

    //hack to modify parent for ios scroll issues
    useEffect(() => {
        if (!isIOS) return;
        const container = document.querySelector('.d2c-container');
        if (!(container instanceof HTMLElement)) return;

        const patchClass = 'd2c-container-requestacall-ios';
        if (!container.classList.contains(patchClass)) {
            container.classList.add(patchClass);
        }

        const updateHeight = () => {
            container.style.height = `${window.innerHeight}px`;
        };

        updateHeight(); // initial run
        window.addEventListener('resize', updateHeight);
        window.addEventListener('orientationchange', updateHeight);

        return () => {
            window.removeEventListener('resize', updateHeight);
            window.removeEventListener('orientationchange', updateHeight);
            container.style.height = ''; // resets to default
            container.classList.remove(patchClass);
        };
    }, []);


    return (
        <MainLayoutPage
            sceneId='container-has-header'
        >
            <div className='global-options-container'>
                <GlobalMenu activeBtn='' />
                <RequestACallForm qrCode={QRcode} />
            </div>
        </MainLayoutPage>
    )
}

export default RequestACallPage